// src/features/notifications/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import NotificationsPage from './pages/NotificationsPage';
import CreateNotificationPage from './pages/CreateNotificationPage';

export const NotificationRoutes = () => (
  <Route path="notifications">
    <Route index element={<NotificationsPage />} />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="notification:create">
          <CreateNotificationPage />
        </ProtectedRoute>
      }
    />
  </Route>
);